import React from 'react';
import { Container } from '@material-ui/core';
import useStyle from './style';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  header?: React.ReactNode;
  headerClassName?: string;
  headerStyle?: React.CSSProperties;
  children: React.ReactNode;
  contentClassName?: string;
  contentStyle?: React.CSSProperties;
}

export default function ({
  className,
  style,
  header,
  headerClassName = '',
  headerStyle,
  children,
  contentClassName = '',
  contentStyle,
}: Props) {
  const classes = useStyle();

  return (
    <Container component="article" className={[classes.root, className || ''].join(' ')} style={style}>
      {header && (
        <header className={[classes.header, headerClassName].join(' ').trim()} style={headerStyle}>
          {header}
        </header>
      )}
      <div className={[classes.content, contentClassName].join(' ').trim()} style={contentStyle}>
        {children}
      </div>
    </Container>
  );
}
